/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FlexibleDateRange } from './FlexibleDateRange';
import {
    FlexibleDateRangeFromJSON,
    FlexibleDateRangeFromJSONTyped,
    FlexibleDateRangeToJSON,
    FlexibleDateRangeToJSONTyped,
} from './FlexibleDateRange';
import type { DateRange } from './DateRange';
import {
    DateRangeFromJSON,
    DateRangeFromJSONTyped,
    DateRangeToJSON,
    DateRangeToJSONTyped,
} from './DateRange';

/**
 * A set of search dates
 * @export
 * @interface SearchDatesV2
 */
export interface SearchDatesV2 {
    /**
     * 
     * @type {Array<DateRange>}
     * @memberof SearchDatesV2
     */
    searchDates?: Array<DateRange>;
    /**
     * 
     * @type {Array<FlexibleDateRange>}
     * @memberof SearchDatesV2
     */
    flexibleSearchDates?: Array<FlexibleDateRange>;
}

/**
 * Check if a given object implements the SearchDatesV2 interface.
 */
export function instanceOfSearchDatesV2(value: object): value is SearchDatesV2 {
    return true;
}

export function SearchDatesV2FromJSON(json: any): SearchDatesV2 {
    return SearchDatesV2FromJSONTyped(json, false);
}

export function SearchDatesV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchDatesV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'searchDates': json['search_dates'] == null ? undefined : ((json['search_dates'] as Array<any>).map(DateRangeFromJSON)),
        'flexibleSearchDates': json['flexible_search_dates'] == null ? undefined : ((json['flexible_search_dates'] as Array<any>).map(FlexibleDateRangeFromJSON)),
    };
}

export function SearchDatesV2ToJSON(json: any): SearchDatesV2 {
    return SearchDatesV2ToJSONTyped(json, false);
}

export function SearchDatesV2ToJSONTyped(value?: SearchDatesV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'search_dates': value['searchDates'] == null ? undefined : ((value['searchDates'] as Array<any>).map(DateRangeToJSON)),
        'flexible_search_dates': value['flexibleSearchDates'] == null ? undefined : ((value['flexibleSearchDates'] as Array<any>).map(FlexibleDateRangeToJSON)),
    };
}

